import { render, staticRenderFns } from "./ClientPlan.vue?vue&type=template&id=57421ce0&scoped=true&"
import script from "./ClientPlan.vue?vue&type=script&lang=js&"
export * from "./ClientPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57421ce0",
  null
  
)

export default component.exports